export const SNACKBAR_MESSAGE = 'SNACKBAR_MESSAGE';

export const updateSnackbar = (state) => (dispatch) => {
    dispatch({ type: SNACKBAR_MESSAGE, state });
};

export default {
    SNACKBAR_MESSAGE,
    updateSnackbar,
};
